import { useNavigate } from "react-router";
import { PATH_CONTACT } from "../../../utility/constants";
import Images from "../../../utility/imagePaths";
import { TechHomeSectionType } from "../../../utility/types/generaTypes";
import Button from "../../common/buttons/button/Button";
import AchievementCard from "../achievementCard/AchievementCard";
import SectionHeader from "../sectionHeader/SectionHeader";
import "./TechHomeSection.css";

type TechHomeSectionProps = {
  homeData: TechHomeSectionType;
};

const TechHomeSection = ({ homeData }: TechHomeSectionProps) => {
  const navigate = useNavigate();

  return (
    <section className="app_detail_section">
      <div className="techSection_left_container">
        <div className="techSection_leftHeader_container">
          <SectionHeader
            title={homeData.sectionHeader}
            style={{ alignSelf: "flex-start" }}
          />
          <h1 className="techSection_title">{homeData.title}</h1>
          <p className="techSection_description">{homeData.description}</p>
        </div>
        <Button
          title="Get Started"
          onClickButton={() => navigate(PATH_CONTACT)}
          backgroundColor="linear-gradient(135deg, hsl(214 84% 56%), hsl(263 70% 50%))"
          className="techGetStart_btn "
          rightComponent={
            <img
              src={Images.SVG_ARROW_RIGHT_WHITE_ICON}
              alt="arrow white"
              className="techGetStart_arrow_right_white"
            />
          }
        />
        <div className="techAchievementCards_container">
          {homeData.achievements.map((achievenment, index) => (
            <AchievementCard
              key={"AchievementCard" + index}
              achivenment={achievenment}
              mainContainerClassname="techAchievenmentCard"
            />
          ))}
        </div>
      </div>
      <img
        src={homeData.img}
        alt="tech"
        className="techSectionR_right_container"
      />
    </section>
  );
};

export default TechHomeSection;
